import "./styles/main.css";
import taggedImage from "../../assets/search-img.png";
import discoverImage from "../../assets/discover.png";
import bookmarkImage from "../../assets/bookmark.png";

function MainSearch({ onOpenSearch }) {
    return (
        <div>
            <div className="home-wrapper">
                <section className="home-section hero-bg">
                    <div className="home-text">
                        <h1 className="h1-48-800">A Trusted Search Engine for Global Projects
                            {/* <span className="custom-underline" > With Confidence.</span> */}
                        </h1>
                        <p>
                            Join the global construction community and showcase your projects worldwide with ConRa. Our search engine expands your reach beyond local markets, connecting you with potential clients suppliers, investors, and industry peers
                        </p>
                        <div className="feature-item-footer">
                            <button
                                type="button"
                                onClick={onOpenSearch}
                                className="faq-button">Search a Project or Company </button>
                        </div>
                        <div className="space3"></div>
                    </div>
                    <div className="home-image-reverse home-image-center">
                        <img src={taggedImage} alt="Team meeting" />
                    </div>

                </section>

                <section className="home-section ">
                    <div className="home-text">
                        <h1 className="h1-48-600">Your projects, discovered worldwide
                            {/* <span className="custom-underline" > With Confidence.</span> */}
                        </h1>
                        <p>
                            Generate a unique project code (e.g., TLSA01) to make it easy for clients, investors, and industry peers worldwide to find and verify your project
                        </p>
                    </div>
                    <div className="home-image-reverse home-image-center">
                        <img src={discoverImage} alt="Team meeting" />
                    </div>

                </section>

                <section className="home-section space2">
                    <div className="home-text">
                        <h1 className="h1-48-600">Bookmarking projects.
                        </h1>
                        <p>
                            Let’s users bookmark your projects and stay connected through the updates you post whether it’s key milestones or daily progress.
                        </p>
                    </div>
                    <div className="home-image-reverse home-image-center">
                        <img src={bookmarkImage} alt="Team meeting" />
                    </div>

                </section>

            </div>
        </div >
    );
}

export default MainSearch;